import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FadeInDirective } from '../../directives/fade-in.directive';
import { RouterModule } from '@angular/router';
import { AppVariables } from '../../app.variables';

@Component({
  selector: 'app-contact-modal',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FadeInDirective, RouterModule],
  templateUrl: './contact-modal.component.html',
  styleUrls: ['./contact-modal.component.scss']
})
export class ContactModalComponent {
  @Output() closed = new EventEmitter<void>();

  private readonly contactUrl = `${AppVariables.authApiBaseUrl}/api/send-contact/`;

  contactForm: FormGroup;
  sending = false;
  sendSuccess = false;
  sendError = false;


  constructor(private fb: FormBuilder, private http: HttpClient) {
    this.contactForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[^@]+@[^@]+\.[^@]+$/)
        ]
      ],
      message: [''],
      rodo: [false, Validators.requiredTrue]
    });
  }

  close() {
    this.closed.emit();
    this.sendSuccess = false;
    this.sendError = false;
    this.contactForm.reset();
  }

  send() {
    if (this.contactForm.invalid) {
      return;
    }

    this.sending = true;
    this.sendSuccess = false;
    this.sendError = false;

    const { email, message, rodo } = this.contactForm.value;

    this.sendContact(email, message, rodo).subscribe({
      next: () => {
        this.sendSuccess = true;
        this.contactForm.reset();
      },
      error: (err) => {
        if (err.status === 429) {
          // Traktuj 429 jak success - przekaż, że wiadomość została wysłana 
          // Dzięki temu użytkownik nie wie, że jego zgłoszenie już istnieje – zawsze widzi komunikat „Dziękujemy za wiadomość!” i nie czuje się zniechęcony.
          // To poprawia UX i nie zdradza szczegółów działania backendu
          this.sendSuccess = true;
          this.contactForm.reset();
        } else {
          this.sendError = true;
        }
        this.sending = false;
      },
      complete: () => {
        this.sending = false;
      }
    });
  }

  sendContact(email: string, message: string, rodo: boolean) {
    // Wysyłka tylko do backendu, bez żadnych sekretów
    return this.http.post(this.contactUrl, { email, message, rodo, environment: AppVariables.environmentName });
  }
}
